import type { LcLotteryNumber } from '@lottocom/frontend-components'

import {
  type HighFrequency_DrawStatus,
  HighFrequency_DrawStatusEnum,
  type HighFrequency_DrawStatusNotOperating,
  type HighFrequency_DrawStatusPending,
  type HighFrequency_DrawStatusReady,
} from '#api/shared/@types/generated/backend/graphql-schema-types'
import { includesIgnoreCase } from '~/utils/array'

import {
  HFG_ADD_ONS,
  HFG_BULLSEYE_ADD_ON,
  HFG_DRAW_RESULT_MAIN_FIELD,
  HFG_MULTIPLIER_ADD_ONS,
  HFG_POSSIBLE_BONUS_ADD_ONS,
} from './highFrequencyGameConstants'

export const isHighFrequencyAddOn = (addOnName: string) =>
  includesIgnoreCase(HFG_ADD_ONS, addOnName)

export const isHighFrequencyBonusNumber = (fieldName: string) =>
  includesIgnoreCase(HFG_POSSIBLE_BONUS_ADD_ONS, fieldName)

export const isHighFrequencyBullseye = (fieldName: string) =>
  includesIgnoreCase([HFG_BULLSEYE_ADD_ON], fieldName)

export const isDesignatedBullseyeNumber = (
  value: LcLotteryNumber['value'],
  fieldName: string,
  bullseyeNumber: Maybe<LcLotteryNumber['value']>,
) =>
  fieldName === HFG_DRAW_RESULT_MAIN_FIELD &&
  value !== undefined &&
  bullseyeNumber != null &&
  String(value) === String(bullseyeNumber)

export const isHighFrequencyMultiplierAddOn = (addOnName: string) =>
  includesIgnoreCase(HFG_MULTIPLIER_ADD_ONS, addOnName)

export const isPendingStatus = (
  drawStatus: HighFrequency_DrawStatus,
): drawStatus is HighFrequency_DrawStatusPending =>
  drawStatus.status === HighFrequency_DrawStatusEnum.Pending

export const isNotOperating = (
  drawStatus: HighFrequency_DrawStatus,
): drawStatus is HighFrequency_DrawStatusNotOperating =>
  drawStatus.status === HighFrequency_DrawStatusEnum.NotOperating

export const isReadyStatus = (
  drawStatus: HighFrequency_DrawStatus,
): drawStatus is HighFrequency_DrawStatusReady =>
  drawStatus.status === HighFrequency_DrawStatusEnum.Ready
